import * as Yup from 'yup';
import { ValidationErrorMessages } from './errors';

export const sectionJobValidator = Yup.object().shape({
  onavPosition: Yup.string().required(ValidationErrorMessages.REQUIRED),
  profile: Yup.mixed().required(ValidationErrorMessages.REQUIRED),
  job: Yup.string().optional(),
});
